<template>
  <div
    style="
      position: absolute;
      width: 100vw;
      height: calc(100vh + 64px);
      top: -64px;
      overflow: hidden;
    "
    class="background"
  >
    <div
      :style="distanceTop"
      class="px-6 pb-6 d-flex flex-column"
      style="
        height: 80vh;
        overflow-y: scroll;
        position: fixed;
        width: 100%;
        margin-top: 12vh;
        scrollbar-width: none;
      "
    >
      <div
        v-for="tour in filteredTours"
        :key="tour.id + tour.name"
        class="d-flex flex-column"
        @click="$router.push(`/tour/${tour.id}`)"
      >
        <div class="d-flex justify-space-between py-4">
          <div class="white--text">
            {{ tour.name }}
          </div>

          <div v-if="tour.tour" class="d-flex align-center justify-center">
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/poi-white.svg"
                style="height: 15px; width: auto"
              />
              <div class="white--text ml-1" style="font-size: 14px">
                {{ tour.count }}
              </div>
            </div>
            <div
              style="height: 20px; width: 0.5px; margin: 0 10px"
              class="white"
            ></div>
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/tour.svg"
                style="height: 15px; width: auto"
              />
              <div class="white--text ml-1" style="font-size: 14px">
                {{ getTime(tour.length_chilometer) }}’
              </div>
            </div>
          </div>
        </div>

        <v-divider class="white"></v-divider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  async mounted() {
    this.setMenuIconColor("white");
    await this.getTours();
    this.filteredTours = this.tours.filter((el) => el.multi_day);
    this.loader = false;
  },

  destroyed() {
    this.setMenuIconColor("blue");
  },

  data() {
    return {
      loader: false,
      filteredTours: [],
    };
  },

  computed: {
    ...mapState({
      tours: (state) => state.routes.tours,
      insets: (state) => state.base.insets,
    }),
    distanceTop() {
      return `margin-top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 12vh)`;
    },
  },

  methods: {
    ...mapMutations(["setMenuIconColor"]),
    ...mapActions(["getTours"]),

    getTime(time) {
      return `${time.split(".")[1]}’`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
